import React from "react";
import ContactPage from "../Components/Contact/ContactPage";
import Footer from "../Components/Footer/Footer";
import Header from "../Components/Header/Navbar"

const Contact: React.FC = () => {

  return(
  <>
  
    <ContactPage/>;
    <Footer/>

  </>

  ) 
};

export default Contact;
